export const ENTITY_TYPES = {
  PATIENT: 'PATIENT'
};

export function generateNeoHealthCardId(type: string): string {
  const ts = Date.now().toString().slice(-6);
  const rand = Math.floor(100000 + Math.random() * 900000);
  return `NHC${ts}${rand}`.slice(0, 12);
}

export function isCanonicalNH12(id: string): boolean {
  return typeof id === 'string' && id.startsWith('NHC') && id.length >= 12;
}

export function isLegacyId(id: string): boolean {
  return typeof id === 'string' && id.startsWith('NHC-');
}

export function formatNeoHealthCardId(id: string): string {
  return id;
}

export function cleanNH12(id: string): string {
  return id.replace(/[^A-Z0-9]/g, '');
}

export function scanUrl(id: string): string {
  return `https://neohealthcard.com/scan/${id}`;
}
